import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Quem pode se tornar parceiro?",
    a: "Sócios de casas de investimentos e assessores com carteira sob assessoria acima de R$ 50 milhões. Cada aplicação é revisada manualmente, caso a caso. Nem toda aplicação é aprovada.",
  },
  {
    q: "Como sei se fui selecionado?",
    a: "Nossa equipe revisa cada aplicação. Se aprovado, entraremos em contato pelo telefone cadastrado para alinhar contrato, onboarding e treinamento.",
  },
  {
    q: "Que produto eu vou divulgar?",
    a: "Crédito estruturado securitizado lastreado em operação real, com 10 anos de histórico e 100% de adimplência. Os detalhes são apresentados após a aprovação.",
  },
  {
    q: "Preciso ter certificação?",
    a: "Sim. O programa é para profissionais certificados e com carteira ativa.",
  },
];

export const EventoFAQ = () => {
  return (
    <section id="faq" className="bg-[#0B1A0B] scroll-mt-24">
      <div className="container-narrow py-16 sm:py-24">
        <div className="max-w-3xl mb-10 sm:mb-14">
          <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-400">
            Antes de aplicar
          </div>
          <h2
            className="mt-4 text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-[1.1]"
            style={{
              fontFamily:
                '"Playfair Display", Georgia, "Times New Roman", serif',
              letterSpacing: "-0.02em",
            }}
          >
            Perguntas Frequentes
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white/[0.04] rounded-2xl border border-white/10 overflow-hidden data-[state=open]:ring-1 data-[state=open]:ring-white/20 data-[state=open]:bg-white/[0.06]"
            >
              <AccordionTrigger className="px-5 sm:px-6 py-4 text-left text-base sm:text-lg font-semibold text-white hover:no-underline [&_svg]:text-zinc-300">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-5 sm:px-6 pb-5 text-sm sm:text-[15px] text-zinc-300 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
